/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const KeySecretJwk: core.serialization.Schema<serializers.KeySecretJwk.Raw, Truvity.KeySecretJwk> =
    core.serialization.string();

export declare namespace KeySecretJwk {
    export type Raw = string;
}
